/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const WatchIcon = ({ width = 24, height = 24, hidden = false, title = 'Watch' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M8 6a1.914 1.914 0 0 0-2 2v20a2.02 2.02 0 0 0 2 2 2.112 2.112 0 0 1 2 2v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a2.112 2.112 0 0 1 2-2 2.021 2.021 0 0 0 2-2V16h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-1V8a1.987 1.987 0 0 0-2.083-2A1.947 1.947 0 0 1 26 4V1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v3a1.875 1.875 0 0 1-2 2Zm18 4v16H10V10Z"
    />
  </svg>`;
};
